
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { TranslatorProfile } from '../../global/models'
import ProfileImage from './ProfileImage.vue'
import AccountingDetails from './Accounting/AccountingDetails.vue'

@Component({
  components: { AccountingDetails, ProfileImage }
})
export default class ProfileDetails extends Vue {
  @Prop({ type: Object, default: null })
  private readonly details!: TranslatorProfile

  get addressDetails() {
    if (!this.details || [this.details.address, this.details.suburb, this.details.postcode, this.details.state, this.details.country].some(i => !i)) {
      return '-'
    }
    return `${this.details.address}, ${this.details.suburb} ${this.details.postcode} ${this.details.state} ${this.details.country}`
  }

  get quickLink() {
    return `${this.$store.state.config.customerFrontendUrl}/providers/${this.details.slug}/create`
  }

  updateLogo(path: string) {
    this.$emit('update:details', { ...this.details, logoPath: path })
  }

  updateBanner(path: string) {
    this.$emit('update:details', { ...this.details, bannerPath: path })
  }

  async copyQuickLink() {
    try {
      await navigator.clipboard.writeText(this.quickLink)
      this.$store.dispatch('success', 'Link copied to clipboard')
    } catch (error) {
      this.$store.dispatch('error', 'Unable to copy link to clipboard')
    }
  }
}
